<template>
  <vs-row vs-justify="center" id="organizations-box">

    <!-- DELETE PROMPT -->
            <div class="centerx con-exemple-prompt">
              <vs-prompt @accept="deleteOrganization(selected.id)" color="danger" @cancel="Closed" @close="Closed" :active.sync="activeDeletePrompt">
                <div class="con-exemple-prompt">
                  Are you sure to delete
                  {{selected.name}}
                  organization ?
                </div>
              </vs-prompt> 
            </div>


                <!-- add organisation espace -->

    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <div slot="header">
            <vs-row>
                <vs-col>
                    <vs-card vs-offset="9" vs-w="3">
                    <vs-button
                        id="add-organization"
                        icon="add"
                        color="primary"
                        @click="createOrganization"
                    >
                    {{$t('Organization.AddOrganizationButton')}}</vs-button>
                    </vs-card>
                </vs-col>

            </vs-row>
            <br>

            <vs-table
              :sst="true"
              @search="handleSearch"
              @selected="handleSelected"
              v-model="selected"
              :total="totalItems"
              max-items="10"
              search
              :data="organizations"
            
            >
            <!-- headers-->
              <template slot="thead">
                <vs-th sort-key="contactname" >#</vs-th>
                <vs-th sort-key="contactname" >{{$t('Organization.Table.Name')}}</vs-th>
                <vs-th sort-key="joindate"  >{{$t('Organization.Table.Email')}}</vs-th>
                <vs-th sort-key="phone" >{{$t('Organization.Table.Phone')}}</vs-th>
                <vs-th sort-key="book_id" >{{$t('Organization.Table.Address')}}</vs-th>
                <vs-th sort-key="book_id" >{{$t('Organization.Table.Industry')}}</vs-th>
                <vs-th>{{$t('Organization.Table.Options')}}</vs-th>
              </template>

              <template slot-scope="{data}">
               <!-- <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">-->
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data  ">

                  <vs-td :data="data[indextr].logo">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                          <img :src="data[indextr].logo" width="50" class="" alt="user" v-if="data[indextr].logo"/>
                          <vs-avatar size="50px" icon="home" v-else></vs-avatar>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="d-flex no-block align-items-center">
                      <div class>
                        <h5 class="mb-0 font-16">{{ data[indextr].name}}</h5>
                        <span class="text-muted">{{ data[indextr].name }}</span>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    <div
                      class="d-flex align-items-center"
                    >{{ data[indextr].email }}</div>
                  </vs-td>

                  <vs-td :data="data[indextr].phone">
                    <div class="d-flex align-items-center">
                      <i class="mdi mdi-phone-classic mr-2 display-8"></i>
                      <span class="text-muted">{{data[indextr].phone}}</span>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].address">
                    <div class="d-flex align-items-center">
                      <span class="text-muted">{{data[indextr].address}}</span>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].industry">
                    <div class="d-flex align-items-center" v-if="data[indextr].industry_id!=null">
                      <i :class="icon"></i>
                      <span class="text-muted">{{data[indextr].industry.name}}</span>
                    </div>
                    <div class="d-flex align-items-center" v-else>
                      <i :class="icon"></i>
                      <span class="text-muted">--</span>
                    </div>
                  </vs-td>
                  <!-- les bouttons delete update and view-->
                  <vs-td>
                    <div class="btn-alignment">
                      <vs-button
                        radius
                        color="primary"
                        type="border"
                        icon="visibility"
                        @click="showOrganization(data[indextr].id)"
                      ></vs-button>
                      <vs-button
                            id="edit-customer-button"
                            radius
                            color="warning"
                            type="border"
                            icon="edit"
                            @click="updateOrganization(data[indextr].id)"
                          ></vs-button>
                      <vs-button
                        radius
                        color="danger"
                        type="border"
                        icon="delete"
                        @click="deleteOrganizationPrompt((data[indextr].id))"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
    <!--pagination-->
                 <vs-pagination
              @change="handleChangePage"
              :total="totalPages"
              v-model="currentPage"
            
              
            >
          

          </vs-pagination>



            
            <!-- <vs-pagination @change="handleChangePage" :total="totalPages"  v-model="currentPage"></vs-pagination> -->
        </div>
        

       



      </vs-card>
    </vs-col>
    
    
  </vs-row>

  
</template>



<script>
import {organizationService, managerService} from '../../_services';
import router from "../../_helpers/router";
import index from 'vue-prism-component';


export default {
    name: "Organizations",
    data: () => ({
        title: "Organizations",
        activeDeletePrompt: false,
        totalPages: 0,
        currentPage: 1,
        selected: {},
        organizations: [],
        importModal: {
        file: null,
          active :  false ,
        
        },
        name:"",
        address:"",
        phone:"",
        email:"",
        searchKeyword: "",


   
    }),
    methods: {
        notify(title, text, type) {
            this.$vs.notify({
                color: type,
                title: title,
                text: text
            });
        },

     





       
        handleSearch(keyword) {
      this.showLoading();
      this.searchKeyword = keyword;
      if (keyword == "") {
        organizationService
          .getPage(1)
          .then(
            function (data) {
            this.organizations = data.organizations.data;
            this.totalItems = data.organizations.total;
            this.maxItems = data.organizations.per_page;
            this.totalPages = data.organizations.last_page;
            }.bind(this)
          )
          .finally(
            function () {
              this.hideLoading();
            }.bind(this)
          );
      }
      organizationService
        .search(keyword, 1)
        .then(
          function (data) {
            this.organizations = data.organizations.data;
            this.totalItems = data.organizations.total;
            this.maxItems = data.organizations.per_page;
            this.totalPages = data.organizations.last_page;
          }.bind(this)
        )
        .finally(
          function () {
            this.hideLoading();
          }.bind(this)
        );
    },








    


        //show loading 
        showLoading() {
            this.$vs.loading({
                container: "#organizations-box",
                scale: 0.6
            });
        },

   
        //hide loeading 
        hideLoading() {
            this.$vs.loading.close("#organizations-box > .con-vs-loading");
        },

        //pagination js 
        handleChangePage(page) {
            this.showLoading();
            organizationService.getPage(page).then(function (data) {
                this.organizations = data.organizations.data;
            }.bind(this)).finally(() => {
                this.hideLoading();
            });
        },
        //create organisation 
        createOrganization() {
            this.$router.push("/organizations/create");
        },
        //delete organisation prompt
        deleteOrganizationPrompt(item) {
          this.selected.id = item;
          this.activeDeletePrompt = true;
        },

        //delete organisation
        deleteOrganization(id){
          this.showLoading();
          organizationService
            .deleteOrganization(id).then(
              function(data) {
                this.handleChangePage(this.currentPage);
                this.notify(
                  this.$t("Toasts.Successful"),
                  this.$t("Customer.DeleteCustomerPrompt.ToastSuccessMessage"),
                  "success"
                );
              }.bind(this)
            )
            .catch(
              function() {
                this.notify(
                  this.$t("Toasts.Error"),
                  this.$t("Customer.DeleteCustomerPrompt.ToastFailMessage"),
                  "danger"
                );
              }.bind(this)
            )
            .finally(
              function() {
                this.hideLoading();
                this.activeDeletePrompt = false;
                this.selected = null;
                router.go();
              }.bind(this)
            );
          
        },
        //show organisation 
        showOrganization(organization_id){
          this.$router.push('/organizations/show/'+organization_id);
        },
        //update organisation 
        updateOrganization(organization_id){
          this.$router.push('/organizations/update/'+organization_id);
        }
    },
    //before starting the 
    mounted() {
        this.showLoading();
      organizationService.getAll().then(function (data) {
          
            this.organizations = data.organizations.data;
            this.totalItems = data.organizations.total;
            this.maxItems = data.organizations.per_page;
            this.totalPages = data.organizations.last_page;
        }.bind(this))
            .finally(() => {
                this.hideLoading();
                console.log(this.organizations)

            });
    }
}
</script>

<style>

</style>